export const environment = {
   base_url: process.env.REACT_APP_LIVE_URL,
   web_socket_url: process.env.REACT_APP_SOCKET_LIVE_URL,
   image_base_url: process.env.REACT_APP_IMAGE_LIVE_URL
}
